/**
 * Canonical option vocabularies for the Risk surface. Single source for the
 * tabs AND the severity contract test: every value here must keep ranking
 * correctly through components/delivery/widgets/severity.ts — the shared
 * regexes that drive both RiskIssueList and the program-home high-severity
 * strip. Change an option string and the contract test tells you whether
 * severity ranking or open/closed filtering just moved.
 */ const lmh = [
    {
        value: 'Low',
        label: 'Low'
    },
    {
        value: 'Medium',
        label: 'Medium'
    },
    {
        value: 'High',
        label: 'High'
    }
];
export const RISK_PROBABILITY = lmh;
export const RISK_IMPACT = lmh;
export const RISK_STATUS = [
    {
        value: 'Open',
        label: 'Open'
    },
    // "Mitigating" is an in-flight risk: it must NOT match isClosed (the
    // regex says "mitigated", past tense, deliberately).
    {
        value: 'Mitigating',
        label: 'Mitigating'
    },
    {
        value: 'Closed',
        label: 'Closed'
    }
];
export const RISK_STRATEGY = [
    {
        value: 'Avoid',
        label: 'Avoid'
    },
    {
        value: 'Transfer',
        label: 'Transfer'
    },
    {
        value: 'Mitigate',
        label: 'Mitigate'
    },
    {
        value: 'Accept',
        label: 'Accept'
    }
];
export const ISSUE_PRIORITY = [
    ...lmh,
    {
        value: 'Critical',
        label: 'Critical'
    }
];
// Matt-issue 18: issue impact was free text; it becomes a select sharing the
// priority vocabulary. Legacy free-text values are preserved per-row by the
// tab (prepended "(legacy)" option), never rewritten.
export const ISSUE_IMPACT = ISSUE_PRIORITY;
export const ISSUE_STATE = [
    {
        value: 'Open',
        label: 'Open'
    },
    {
        value: 'In Progress',
        label: 'In Progress'
    },
    {
        value: 'Resolved',
        label: 'Resolved'
    }
];
